<div class="ad-banner" *ngIf="showBanner">
    <img *ngFor="let ad of advertisementList" [src]="ad.imageUrl" class="ad-image" />
</div>
